export default {
  data() {
    return {
      universities: []
    };
  },
  computed: {
    universitiesURL() {
      return (
        this.trailingSlash(process.env.VUE_APP_ENROLLMENT_URL) +
        "api/universities"
      );
    }
  },
  created() {
    this.getUniversities();
  },
  methods: {
    trailingSlash(url) {
      return url.replace(/\/?$/, "/");
    },
    getUniversities() {
      fetch(this.universitiesURL)
        .then(response => {
          if (!response.ok) throw Error(response.status);
          return response.json();
        })
        .then(data => {
          data.sort((a, b) => a.label.localeCompare(b.label));
          this.universities = data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    searchUniversity(search, loading) {
      loading(true);

      fetch(this.universitiesURL + "?search=" + encodeURIComponent(search))
        .then(response => {
          if (!response.ok) throw Error(response.status);
          return response.json();
        })
        .then(data => {
          data.sort((a, b) => a.label.localeCompare(b.label));
          this.universities = data;
          loading(false);
        })
        .catch(error => {
          console.error(error);
          loading(false);
        });
    }
  }
};
